export const phoneNumberMasker = (newVal) => {
    const onlyNumbers = newVal.match(/\d+/g);
    if (!onlyNumbers) {
        return '';
    }
    const nums = onlyNumbers.join('');
    if (nums.length >= 10) {
        const firstThree = nums.slice(0, 3);
        const middleThree = nums.slice(3, 6);
        const lastFour = nums.slice(6, 10);
        const formattedNumber = `(${firstThree}) ${middleThree}-${lastFour}`;
        return formattedNumber;
    }
    else if (nums.length >= 7) {
        const firstThree = nums.slice(0, 3);
        const middleThree = nums.slice(3, 6);
        const formattedNumber = `(${firstThree}) ${middleThree}-${nums.slice(6)}`;
        return formattedNumber;
    }
    else if (nums.length >= 4) {
        const firstThree = nums.slice(0, 3);
        const formattedNumber = `(${firstThree}) ${nums.slice(3)}`;
        return formattedNumber;
    }
    else if (nums.length >= 3) {
        const formattedNumber = `(${nums}`;
        return formattedNumber;
    }
    else {
        return `(${nums}`;
    }
};
//# sourceMappingURL=phone-number-mask.js.map